import React, { useMemo } from "react"
import { useParams, Outlet, useOutletContext } from "react-router-dom"

import { isMobile } from "@components/constants"

import Header from "./Header"


const InvestorProjectLayout = () => {
  const { projectId: id } = useParams()

  const context = useOutletContext()
  const { getProject, projects } = context

  const project = useMemo(() => getProject(id), [ id, projects ])

  const containerStyle = isMobile
    ? {
        overflow: "hidden",
      }
    : {}

  return (
    <div style={containerStyle}>
      <Header project={project} />
      <Outlet context={{ ...context, project }} />
    </div>
  )
}

export default InvestorProjectLayout
